<template>
  <!-- Termly Tracking Code -->
  <div id="terms" name="termly-embed" data-id="a917e558-6512-411d-a54d-d5c7f60cdd9c" data-type="iframe"></div>
</template>


<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TermsView',
  methods: { 
    init: function(d, s, id) {
      var js, tjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        d.getElementById(id).remove();
        tjs = d.getElementsByTagName(s)[1];
      } 
      js = d.createElement(s);
      js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      tjs.parentNode.insertBefore(js, tjs);
    }
  },
  mounted: function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.querySelector(".navbar.background").style.opacity = 1;
    document.querySelector(".logo img").style.filter = 'brightness(1) invert(0)'
    document.querySelector(".logo span").style.filter = 'brightness(1) invert(0)'
    this.init(document, 'script', 'termly-jssdk');
  }
})
</script>

<style scoped lang="scss">
  #terms {
    padding-top: 3.2em;
    padding-bottom: 100vh;
  }
</style>